// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"427df941","453":"cf006a0d","455":"b897966b","977":"0b393671"}[chunkId] + ".chunk.js";
};